export default "__VITE_ASSET__d66b5556__"